import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import Banner from "../components/Banner";
import { postArrive } from "../wordpress/operations/post-arrive";

const Layout = () => {
    useEffect(() => {
        // mech_session håller den valda tiden reserverad under bokningen
        // (Reservation per session) och överlever därför en omladdning.
        // Ankomsten anmäls varje gång; bokningssystemet räknar bara den första
        // per session, så ingen egen flagga behövs i webbläsaren.
        let session = parseInt(sessionStorage.getItem('mech_session') || '0');
        if (!session) {
            session = Date.now();
            sessionStorage.setItem('mech_session', session.toString());
        }
        sessionStorage.removeItem('mech_arrived'); // Från tidigare versioner.
        postArrive(session, window.react_data.landing_url || window.location.href, window.react_data.referer || '');
    }, []);

    return (
        <>
            <div className="wco-booking-template-default">
                <Banner />
                <Outlet />
            </div>
        </>
)
};

export default Layout;